'use client';

import { useRouter } from 'next/router';
import styles from './ControlPanel.module.css';
import { useState, useRef, useEffect } from 'react';

const ControlPanel = ({}) => {
    const [showDevNotice, setShowDevNotice] = useState(false);
    const [noticePosition, setNoticePosition] = useState({ x: 0, y: 0 });
    const [noticeTarget, setNoticeTarget] = useState(null);
    const noticeTimerRef = useRef(null);
    const router = useRouter();

    // Функция для показа уведомления "В разработке"
    const showDevelopmentNotice = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setNoticePosition({
            x: rect.left + rect.width / 2,
            y: rect.top - 10 // Позиционируем сверху
        });
        setNoticeTarget(e.currentTarget);
        setShowDevNotice(true);
        
        if (noticeTimerRef.current) {
            clearTimeout(noticeTimerRef.current);
        }
        
        noticeTimerRef.current = setTimeout(() => {
            setShowDevNotice(false);
        }, 2000);
    };

    const openTelegram = () => {
        window.open('https://t.me/+igthUWdHxoJlNDhi', '_blank');
    };

    const handleLogoClick = () => {
        router.push(`/`);
    };

    const openCatalog = () => {
        router.push(`/catalog`);
    };

    // Очистка таймера при размонтировании
    useEffect(() => {
        return () => {
            if (noticeTimerRef.current) {
                clearTimeout(noticeTimerRef.current);
            }
        };
    }, []);

    return (
        <div className={styles.controlWrapper}>
            <div className={styles.panelElem} onClick={openTelegram}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 600 600">
                    <defs>
                        <linearGradient id="gradient5" x1="0%" y1="50%" x2="100%" y2="50%">
                        <stop offset="0%" stopColor="#EEBE28" stopOpacity="1"/>
                        <stop offset="100%" stopColor="#EEBE28" stopOpacity="1"/>
                        </linearGradient>
                    </defs>
                    <path d="M20.4692 312.929L54.161 324.11C67.569 329.531 122.232 342.745 143.548 344.778C160.6 346.404 186.407 333.258 197.18 326.482L424.428 177.062C428.095 174.69 436.735 171.166 441.961 176.045C447.187 180.924 444.138 186.888 441.961 189.259L293.786 329.87C281.295 340.825 256.175 365.92 255.625 378.66C255.074 391.4 268.918 404.072 275.908 408.815C323.237 440.213 421.746 505.582 437.148 515.882C456.401 528.758 470.496 537.228 493.53 532.823C511.958 529.3 522.524 497.021 525.503 481.323C544.756 373.578 583.879 148.194 586.355 108.62C589.449 59.1524 581.542 55.7642 559.883 54.0701C542.555 52.7148 492.384 71.3499 469.465 80.8369C333.093 136.629 51.892 253.025 18.0626 272.27C-15.7667 291.516 5.57143 307.395 20.4692 312.929Z" fill="url(#gradient5)"/>
                </svg>
                <p className={styles.buttonLabel}>Мы в тг</p>
            </div>
            <div className={styles.panelElem} onClick={openCatalog}>
                <svg style={{transform: "translateX(-3px) scale(0.85)"}} xmlns="http://www.w3.org/2000/svg" width="37px" height="25px" viewBox="1150 0 450 600">
                    <defs>
                        <linearGradient id="solidGold1" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#EEBE28"/>
                        <stop offset="100%" stopColor="#EEBE28"/>
                        </linearGradient>
                    </defs>
                    <rect x="1171" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1384" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1597" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1171" y="213" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1384" y="213" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1597" y="213" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1171" y="426" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1384" y="426" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                    <rect x="1597" y="426" width="162" height="162" rx="39" fill="url(#solidGold1)"/>
                </svg>
                <p className={styles.buttonLabel}>Каталог</p>
            </div>
            <div className={styles.panelElem} onClick={handleLogoClick}>
                <img className={styles.panelLogo} src="/logo/Mango_Logo_Control.svg" alt="MANGO"/>
            </div>
            <div className={styles.panelElem} onClick={showDevelopmentNotice}>
                <svg style={{transform: "translateX(-0px) scale(0.86)"}} xmlns="http://www.w3.org/2000/svg" width="36px" height="25px" viewBox="5300 0 600 600">
                    <defs>
                        <linearGradient id="gradient6" x1="0%" y1="50%" x2="100%" y2="50%">
                        <stop offset="0%" stopColor="#F5B740"/>
                        <stop offset="100%" stopColor="#FFAA77"/>
                        </linearGradient>
                    </defs>
                    <path d="M5392.91 581.145C5404.1 586.894 5416.48 588.455 5428.42 585.625C5440.36 582.795 5451.32 575.705 5459.86 565.281L5552.89 454.093C5567.28 436.895 5593.72 436.895 5608.11 454.093L5701.14 565.281C5706.77 572.139 5713.47 577.589 5720.86 581.314C5728.25 585.039 5736.18 586.966 5744.19 586.984C5752.43 586.955 5760.58 584.971 5768.17 581.145C5779.46 575.657 5789.11 566.207 5795.85 554.029C5802.6 541.851 5806.13 527.512 5806 512.883V124.173C5805.96 91.5176 5795.15 60.2107 5775.94 37.1198C5756.72 14.0288 5730.67 1.03912 5703.5 1L5457.5 1C5430.33 1.03912 5404.28 14.0288 5385.06 37.1198C5365.85 60.2107 5355.04 91.5176 5355 124.173V512.883C5354.87 527.523 5358.42 541.871 5365.18 554.05C5371.94 566.229 5381.61 575.672 5392.91 581.145Z" fill="url(#gradient6)"/>
                </svg>
                <p className={styles.buttonLabel}>Закладки</p>
            </div>
            
            <div className={styles.panelElem} onClick={showDevelopmentNotice}>
                <svg style={{transform: "translateY(0px) scale(1.00)"}} xmlns="http://www.w3.org/2000/svg" width="29px" height="25px" viewBox="6300 0 600 600">
                    <defs>
                        <linearGradient id="gradient7" x1="0%" y1="50%" x2="100%" y2="50%">
                        <stop offset="0%" stopColor="#FEAA75"/>
                        <stop offset="100%" stopColor="#FFA884"/>
                        </linearGradient>
                    </defs>
                    <path d="M6324.25 142.451C6318.56 121.058 6332.9 99.4239 6354.48 94.5363C6359.45 93.4145 6477.85 67 6617.05 67C6756.26 67 6874.68 93.4145 6879.65 94.5363C6901.23 99.4239 6914.75 120.871 6909.86 142.451C6904.97 164.031 6883.47 177.546 6861.94 172.685C6860.82 172.444 6747.26 147.125 6617.05 147.125C6486.85 147.125 6373.29 172.444 6372.17 172.685C6369.2 173.353 6334.08 179.415 6324.25 142.451Z" fill="url(#gradient7)"/>
                    <path d="M6324.25 316.126C6318.56 294.732 6332.9 273.098 6354.48 268.211C6359.45 267.089 6477.85 240.675 6617.05 240.675C6756.26 240.675 6874.68 267.089 6879.65 268.211C6901.23 273.098 6914.75 294.545 6909.86 316.126C6904.97 337.706 6883.47 351.22 6861.94 346.359C6860.82 346.119 6747.26 320.8 6617.05 320.8C6486.85 320.8 6373.29 346.119 6372.17 346.359C6369.2 347.027 6334.08 353.09 6324.25 316.126Z" fill="url(#gradient7)"/>
                    <path d="M6324.25 489.8C6318.56 468.407 6332.9 446.773 6354.48 441.885C6359.45 440.764 6477.85 414.349 6617.05 414.349C6756.26 414.349 6874.68 440.764 6879.65 441.885C6901.23 446.773 6914.75 468.22 6909.86 489.8C6904.97 511.381 6883.47 524.895 6861.94 520.034C6860.82 519.794 6747.26 494.474 6617.05 494.474C6486.85 494.474 6373.29 519.794 6372.17 520.034C6369.2 520.702 6334.08 526.765 6324.25 489.8Z" fill="url(#gradient7)"/>
                </svg>
                <p className={styles.buttonLabel}>Меню</p>
            </div>

            {showDevNotice && (
                <div 
                    className={styles.devNotice} 
                    style={{
                        position: 'fixed',
                        left: `${noticePosition.x}px`,
                        top: `${noticePosition.y}px`,
                        transform: 'translateX(-50%) translateY(-100%)'
                    }}
                >
                    В разработке
                </div>
            )}
        </div>
    );
};

export default ControlPanel;